import { render, staticRenderFns } from "./proto_huawei.vue?vue&type=template&id=eb067cc6&scoped=true&"
import script from "./proto_huawei.vue?vue&type=script&lang=js&"
export * from "./proto_huawei.vue?vue&type=script&lang=js&"
import style0 from "./proto_huawei.vue?vue&type=style&index=0&id=eb067cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb067cc6",
  null
  
)

export default component.exports